const initialLogisticsState = {
    // Normal filters
    receiptDate: "",
    vendorShipmentNo: "",
    senderName: "",
    schoolNumber: "",
    linesLinkedSelected: "",
    logisticsSavedSelected: "",
    setReceiptDate: () => { },
    setVendorShipmentNo: () => { },
    setSenderName: () => { },
    setSchoolNumber: () => { },
    setLinesLinkedSelected: () => { },
    setLogisticsSavedSelected: () => { },
    // Page hidden filters
    returnMarkValue: 0,
    barcodeIsLinked: true,
    disabled: 0,
    setReturnMarkValue: () => { },
    setBarcodeIsLinked: () => { },
    setBarcodeIsNotLinked: () => { },
    setExtraReceipts: () => { },
    setDisabled: () => { },
    // Paginator
    pageSize: 10,
    currentPage: 1,
    setPageSize: () => { },
    setCurrentPage: () => { },
};

export default initialLogisticsState;